import Vue from 'vue'
import css from "./css/app.scss";
import * as c from './components';
import {publish, subscribe} from './util/pubsub';
import fitvids from "fitvids";
import LL from 'vanilla-lazyload';
import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";
import Glide from '@glidejs/glide';
import glide_css from '@glidejs/glide/dist/css/glide.core.min.css';

window.publish = publish;
window.subscribe = subscribe;
Vue.config.productionTip = false
window.Vue = Vue;
fitvids({selector: 'iframe'});
window.lazyload = new LL();
window._glide = Glide;

Sentry.init({
  dsn: "https://ec346cc804404ae4b55c113aec41bfb5@o136913.ingest.sentry.io/5879933",
});

const nlt = document.getElementById('newsletter-target');
if (nlt) {
    const iframe = document.querySelector('[data-w-type=pop-in]');
    const ifInterval = setInterval(() => {
      if (iframe.style.position !== 'fixed') {
        iframe.style.position = 'fixed';
      }
    }, 150);
}